import { SearchRequest } from '@empathy/search-adapter';
import { filter } from 'rxjs/operators/filter';

export function requestHasQuery() {
  return filter((request: SearchRequest) => !!request.query);
}
